import { ShiftFormType } from 'components/shifts/ShiftForm';

export const updateShiftInitialValues: Partial<ShiftFormType> = {};
